import { render } from "./VsListItem.vue?vue&type=template&id=3cc36b11"
import script from "./VsListItem.vue?vue&type=script&lang=js"
export * from "./VsListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__